/**
 * @generated SignedSource<<f1e54aa38bf32a5d65c82f50dd65a563>>
 * @relayHash 0a1ca51e635f23fb627bb7522bb8974a
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/571.0.0-2026-08-05T11:58:36.824Z/PdpRespMarketplaceLayoutPrimaryRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type types = "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type PdpRespMarketplaceLayoutPrimaryRefetchQuery$variables = {
  afterDisplay: boolean;
  afterDisplayOrBtSsr: boolean;
  fetchPdp: boolean;
  fetchUser: boolean;
  followSearchPages?: ReadonlyArray<string | null> | null;
  followSearchTypes?: ReadonlyArray<types | null> | null;
  isEstimateSimilarSoldVariant: boolean;
  isInteractivePdpChat: boolean;
  isMultiSku: boolean;
  isPdpImageGalleryRedesignVariant: boolean;
  isPdpSimilarSoldItemsModuleVariant: boolean;
  isTrade: boolean;
  itemId: string;
  itemIds: ReadonlyArray<string | null>;
  personalizationId?: string | null;
  priceBookName?: string | null;
  similarItemsCount?: number | null;
  userCountryCode?: string | null;
  userId: string;
  userIds?: ReadonlyArray<string | null> | null;
  userZipCode?: string | null;
};
export type PdpRespMarketplaceLayoutPrimaryRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceLayoutPrimary_viewer">;
  };
};
export type PdpRespMarketplaceLayoutPrimaryRefetchQuery = {
  response: PdpRespMarketplaceLayoutPrimaryRefetchQuery$data;
  variables: PdpRespMarketplaceLayoutPrimaryRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "afterDisplay"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "afterDisplayOrBtSsr"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchPdp"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchUser"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "followSearchPages"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "followSearchTypes"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEstimateSimilarSoldVariant"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isInteractivePdpChat"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isMultiSku"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isPdpImageGalleryRedesignVariant"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isPdpSimilarSoldItemsModuleVariant"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isTrade"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "itemId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "itemIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "personalizationId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "priceBookName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "similarItemsCount"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userCountryCode"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userZipCode"
  }
],
v1 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v2 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v3 = [
  (v1/*:: as any*/),
  (v2/*:: as any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  (v4/*:: as any*/),
  (v5/*:: as any*/)
],
v7 = [
  {
    "kind": "Variable",
    "name": "itemIds",
    "variableName": "itemIds"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v10 = [
  (v9/*:: as any*/)
],
v11 = [
  {
    "kind": "Literal",
    "name": "photoType",
    "value": "DEALER_STOREFRONT_HEADSHOT"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v14 = [
  (v12/*:: as any*/),
  (v13/*:: as any*/),
  (v5/*:: as any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*:: as any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v18 = [
  {
    "kind": "Literal",
    "name": "fullCountryName",
    "value": true
  }
],
v19 = {
  "kind": "Literal",
  "name": "feedbackSellerPublicNoteHasText",
  "value": true
},
v20 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v21 = {
  "kind": "Literal",
  "name": "minimumReviewRating",
  "value": 4
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v23 = [
  (v22/*:: as any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v25 = [
  (v2/*:: as any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rating",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v29 = [
  (v9/*:: as any*/),
  {
    "kind": "Literal",
    "name": "page",
    "value": "pdp"
  }
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showAcceptOffer",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showPurchase",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showMakeOffer",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showRequestPrice",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showFollowCategory",
  "storageKey": null
},
v35 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "small"
  }
],
v36 = {
  "alias": null,
  "args": (v35/*:: as any*/),
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"small\")"
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skuId",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkable",
  "storageKey": null
},
v39 = [
  (v13/*:: as any*/),
  (v38/*:: as any*/)
],
v40 = [
  (v17/*:: as any*/),
  (v5/*:: as any*/)
],
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeOption",
  "kind": "LinkedField",
  "name": "option",
  "plural": false,
  "selections": (v40/*:: as any*/),
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detailKey",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browseUrl",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v47 = [
  (v45/*:: as any*/),
  (v46/*:: as any*/)
],
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": (v47/*:: as any*/),
  "storageKey": null
},
v49 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "unit",
    "storageKey": null
  },
  (v22/*:: as any*/)
],
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertical",
  "storageKey": null
},
v51 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v52 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "htmlCopy",
    "storageKey": null
  }
],
v53 = {
  "kind": "Literal",
  "name": "catchNonFatalErrors",
  "value": false
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textType",
  "storageKey": null
},
v55 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v56 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v57 = [
  (v9/*:: as any*/),
  (v55/*:: as any*/),
  (v56/*:: as any*/),
  (v51/*:: as any*/)
],
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": [
    (v46/*:: as any*/),
    (v45/*:: as any*/)
  ],
  "storageKey": null
},
v59 = [
  (v58/*:: as any*/)
],
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "price",
  "plural": false,
  "selections": (v59/*:: as any*/),
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "minAmount",
  "plural": false,
  "selections": (v59/*:: as any*/),
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "maxAmount",
  "plural": false,
  "selections": (v59/*:: as any*/),
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArt",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdpURL",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "largePath",
  "storageKey": null
},
v67 = {
  "kind": "Literal",
  "name": "includePlayButton",
  "value": false
},
v68 = {
  "kind": "Literal",
  "name": "pad",
  "value": false
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v71 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "adaptive"
  }
],
v72 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "link",
    "storageKey": null
  }
],
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v74 = {
  "kind": "Literal",
  "name": "addLabel",
  "value": false
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceTrackingParams",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "masterOrZoomPath",
  "storageKey": null
},
v77 = [
  (v9/*:: as any*/),
  {
    "kind": "Literal",
    "name": "canShowOnHoldForDifferentBuyer",
    "value": false
  },
  (v53/*:: as any*/),
  (v55/*:: as any*/),
  (v56/*:: as any*/),
  (v51/*:: as any*/)
],
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVatIncluded",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": (v77/*:: as any*/),
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "originalConvertedAmountList",
      "plural": true,
      "selections": (v47/*:: as any*/),
      "storageKey": null
    },
    (v48/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "privateOfferConvertedAmountList",
      "plural": true,
      "selections": (v47/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quantityDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "percentageOff",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "privateOfferPercentageOff",
      "storageKey": null
    },
    (v54/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amountType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showPriceLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offerExpirationDate",
      "storageKey": null
    },
    (v78/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceBookName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryCode",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryPath",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasUnlimitedQuantity",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "USD",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedPdpUrl",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRingItem",
  "storageKey": null
},
v88 = [
  (v48/*:: as any*/),
  (v78/*:: as any*/)
],
v89 = [
  (v9/*:: as any*/),
  {
    "kind": "Literal",
    "name": "isBuyerEstimateEnabled",
    "value": true
  },
  (v55/*:: as any*/),
  (v56/*:: as any*/),
  (v51/*:: as any*/)
],
v90 = {
  "condition": "afterDisplay",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": (v89/*:: as any*/),
      "concreteType": "PricingGuidance",
      "kind": "LinkedField",
      "name": "pricingGuidance",
      "plural": false,
      "selections": [
        (v60/*:: as any*/),
        (v61/*:: as any*/),
        (v62/*:: as any*/)
      ],
      "storageKey": null
    }
  ]
},
v91 = {
  "alias": null,
  "args": [
    (v51/*:: as any*/),
    (v2/*:: as any*/),
    {
      "kind": "Variable",
      "name": "userZipCode",
      "variableName": "userZipCode"
    }
  ],
  "kind": "ScalarField",
  "name": "pdpTrackingVpvParams",
  "storageKey": null
},
v92 = [
  (v46/*:: as any*/),
  (v58/*:: as any*/)
],
v93 = [
  {
    "alias": null,
    "args": (v10/*:: as any*/),
    "kind": "ScalarField",
    "name": "hasRequestedHoldForBuyer",
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v29/*:: as any*/),
    "concreteType": "ItemDisplayInfo",
    "kind": "LinkedField",
    "name": "displayInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CTADisplay",
        "kind": "LinkedField",
        "name": "ctas",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "showHoldRequest",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v94 = {
  "condition": "fetchUser",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": (v10/*:: as any*/),
      "kind": "ScalarField",
      "name": "hasActiveHoldForBuyer",
      "storageKey": null
    }
  ]
},
v95 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "thumb"
  }
],
v96 = [
  (v64/*:: as any*/),
  (v5/*:: as any*/)
],
v97 = {
  "alias": "photoUrl",
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "master"
    }
  ],
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"master\")"
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "measurementUnit",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "kind": "LinkedField",
  "name": "measurement",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemConvertedMeasurementsType",
      "kind": "LinkedField",
      "name": "convertedMeasurementsList",
      "plural": true,
      "selections": [
        (v98/*:: as any*/),
        (v70/*:: as any*/),
        (v69/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "depth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "diameter",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "secondaryHeight",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "concreteType": "MCAnalytics",
  "kind": "LinkedField",
  "name": "analytics",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MCAnalyticsMetrics",
      "kind": "LinkedField",
      "name": "metrics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MCMetricResponseTime",
          "kind": "LinkedField",
          "name": "responseTime",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "summaryCopy",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v101 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CTADisplay",
    "kind": "LinkedField",
    "name": "ctas",
    "plural": false,
    "selections": [
      (v32/*:: as any*/)
    ],
    "storageKey": null
  }
],
v102 = [
  (v46/*:: as any*/),
  (v45/*:: as any*/),
  (v48/*:: as any*/)
],
v103 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 4
  },
  (v1/*:: as any*/),
  {
    "kind": "Literal",
    "name": "requestSourceRole",
    "value": "BUYER"
  }
],
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itemId",
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "singleItemSoldPrice",
  "storageKey": null
},
v107 = {
  "condition": "afterDisplay",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": (v103/*:: as any*/),
      "concreteType": "SimilarSoldItemsConnectionConnection",
      "kind": "LinkedField",
      "name": "similarSoldItemsConnection",
      "plural": false,
      "selections": [
        (v105/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "SimilarSoldItemsConnectionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SimilarSoldItemsNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v106/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "item",
                  "plural": false,
                  "selections": [
                    (v44/*:: as any*/),
                    (v80/*:: as any*/),
                    (v75/*:: as any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v108 = [
  (v8/*:: as any*/),
  (v5/*:: as any*/)
],
v109 = [
  (v46/*:: as any*/)
],
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCanceled",
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v113 = [
  (v9/*:: as any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "page",
    "value": 0
  }
],
v114 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v115 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v116 = {
  "alias": "similarSoldItemsResults",
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 0
    },
    (v1/*:: as any*/)
  ],
  "concreteType": "SimilarSoldItemsConnection",
  "kind": "LinkedField",
  "name": "similarSoldItems",
  "plural": false,
  "selections": [
    (v105/*:: as any*/)
  ],
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "daysRelativeToExpiration",
  "storageKey": "daysRelativeToExpiration(truncate:false)"
},
v118 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "pages",
    "variableName": "followSearchPages"
  },
  {
    "kind": "Variable",
    "name": "types",
    "variableName": "followSearchTypes"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PdpRespMarketplaceLayoutPrimaryRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpRespMarketplaceLayoutPrimary_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "PdpRespMarketplaceLayoutPrimaryRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "suppressNewSellerSignals",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "suppressNewSellerSignals"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"suppressNewSellerSignals\")"
          },
          {
            "alias": null,
            "args": (v3/*:: as any*/),
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "activePromotion",
            "plural": false,
            "selections": (v6/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "videoUploadToolsFeatureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "videoUploadTools"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"videoUploadTools\")"
          },
          {
            "alias": "vimeoItemsVideoHLSPlayerFF",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "vimeoItemsVideoHLSPlayer"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"vimeoItemsVideoHLSPlayer\")"
          },
          {
            "alias": null,
            "args": (v7/*:: as any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "itemRead",
            "plural": true,
            "selections": [
              (v8/*:: as any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "itemIsOnHold",
                    "args": (v10/*:: as any*/),
                    "kind": "ScalarField",
                    "name": "isOnHold",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Seller",
                    "kind": "LinkedField",
                    "name": "seller",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAccessible",
                        "storageKey": null
                      },
                      (v5/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SellerTimeAway",
                        "kind": "LinkedField",
                        "name": "activeTimeAway",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endDate",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "isRewardsTier2",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "listName",
                            "value": "SELLER_REWARDS_2"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "isAnchorListMember",
                        "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StorefrontProfile",
                        "kind": "LinkedField",
                        "name": "liveStorefrontProfile",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "aboutUsUnbranded",
                            "storageKey": null
                          },
                          (v5/*:: as any*/),
                          {
                            "alias": "headshots",
                            "args": (v11/*:: as any*/),
                            "concreteType": "Photo",
                            "kind": "LinkedField",
                            "name": "photos",
                            "plural": true,
                            "selections": (v14/*:: as any*/),
                            "storageKey": "photos(photoType:\"DEALER_STOREFRONT_HEADSHOT\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MediaAlbum",
                            "kind": "LinkedField",
                            "name": "galleryAlbum",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MediaElement",
                                "kind": "LinkedField",
                                "name": "mediaList",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "element",
                                    "plural": false,
                                    "selections": [
                                      (v8/*:: as any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v13/*:: as any*/)
                                        ],
                                        "type": "Photo",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v15/*:: as any*/)
                                        ],
                                        "type": "Video",
                                        "abstractKey": null
                                      },
                                      (v16/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v5/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "establishmentYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v11/*:: as any*/),
                            "concreteType": "Photo",
                            "kind": "LinkedField",
                            "name": "photos",
                            "plural": true,
                            "selections": (v14/*:: as any*/),
                            "storageKey": "photos(photoType:\"DEALER_STOREFRONT_HEADSHOT\")"
                          }
                        ],
                        "storageKey": null
                      },
                      (v17/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                        "kind": "LinkedField",
                        "name": "orderFeedbackPdp",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AggregatedOrderFeedbackType",
                                "kind": "LinkedField",
                                "name": "aggregatedFeedback",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AggregatedOrderFeedbackQuestionType",
                                    "kind": "LinkedField",
                                    "name": "overallExperience",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "mean",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "publicNoteTotalResults",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "monthsSinceStartDate",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "unit",
                            "value": "MONTH"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "timeSinceStartDate",
                        "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SellerProfile",
                        "kind": "LinkedField",
                        "name": "sellerProfile",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "company",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "shippingAddress",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "displayFullCityStateCountry",
                            "args": (v18/*:: as any*/),
                            "kind": "ScalarField",
                            "name": "displayCityStateCountry",
                            "storageKey": "displayCityStateCountry(fullCountryName:true)"
                          },
                          (v5/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SellerTiers",
                        "kind": "LinkedField",
                        "name": "sellerTiers",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isGoldTier",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isPlatinumTier",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sellerTierDataNotFound",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "dealerDetailsHeaderFeedback",
                        "args": [
                          (v19/*:: as any*/),
                          (v20/*:: as any*/),
                          (v21/*:: as any*/)
                        ],
                        "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                        "kind": "LinkedField",
                        "name": "orderFeedbackPdp",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v8/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "orderFeedbackPdp(feedbackSellerPublicNoteHasText:true,first:3,minimumReviewRating:4)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isDistinguished",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "agreementStart",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sellerOrderQuantity",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MCAnalytics",
                        "kind": "LinkedField",
                        "name": "analytics",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MCAnalyticsMetrics",
                            "kind": "LinkedField",
                            "name": "metrics",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MCMetricResponseTime",
                                "kind": "LinkedField",
                                "name": "responseTime",
                                "plural": false,
                                "selections": (v23/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeAssociation",
                        "kind": "LinkedField",
                        "name": "tradeAssociations",
                        "plural": true,
                        "selections": [
                          (v17/*:: as any*/),
                          (v24/*:: as any*/),
                          (v5/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isInternal",
                        "storageKey": null
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v25/*:: as any*/),
                            "concreteType": "BuyerOrderReviewType",
                            "kind": "LinkedField",
                            "name": "buyerOrderReview",
                            "plural": false,
                            "selections": [
                              (v26/*:: as any*/),
                              (v27/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "image",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "pdpUrl",
                                "storageKey": null
                              },
                              (v8/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "dealerDetailsOrderFeedbackPdp",
                            "args": [
                              (v19/*:: as any*/),
                              (v20/*:: as any*/),
                              (v21/*:: as any*/),
                              {
                                "kind": "Literal",
                                "name": "sortBy",
                                "value": "sellerExperienceDesc"
                              }
                            ],
                            "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                            "kind": "LinkedField",
                            "name": "orderFeedbackPdp",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrderFeedbackPdp",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "completedDate",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Transaction",
                                        "kind": "LinkedField",
                                        "name": "transaction",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "User",
                                            "kind": "LinkedField",
                                            "name": "buyer",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Profile",
                                                "kind": "LinkedField",
                                                "name": "profile",
                                                "plural": false,
                                                "selections": [
                                                  (v28/*:: as any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v5/*:: as any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Shipment",
                                            "kind": "LinkedField",
                                            "name": "shipment",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Address",
                                                "kind": "LinkedField",
                                                "name": "shippingAddress",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "displayState",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "displayCountry",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "country",
                                                    "storageKey": null
                                                  },
                                                  (v5/*:: as any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v5/*:: as any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v5/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "overallExperience",
                                        "plural": false,
                                        "selections": [
                                          (v8/*:: as any*/),
                                          (v26/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "publicNote",
                                        "plural": false,
                                        "selections": [
                                          (v8/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "freetext",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v5/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "orderFeedbackPdp(feedbackSellerPublicNoteHasText:true,first:3,minimumReviewRating:4,sortBy:\"sellerExperienceDesc\")"
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v29/*:: as any*/),
                    "concreteType": "ItemDisplayInfo",
                    "kind": "LinkedField",
                    "name": "displayInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CTADisplay",
                        "kind": "LinkedField",
                        "name": "ctas",
                        "plural": false,
                        "selections": [
                          (v30/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PriceInfoDisplay",
                        "kind": "LinkedField",
                        "name": "pricing",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showSale",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showNet",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PriceInfoDisplay",
                            "kind": "LinkedField",
                            "name": "pricing",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showSold",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showUnavailable",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "afterDisplayOrBtSsr",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CTADisplay",
                            "kind": "LinkedField",
                            "name": "ctas",
                            "plural": false,
                            "selections": [
                              (v31/*:: as any*/),
                              (v32/*:: as any*/),
                              (v33/*:: as any*/),
                              (v34/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSkuType",
                    "kind": "LinkedField",
                    "name": "skus",
                    "plural": true,
                    "selections": [
                      (v17/*:: as any*/),
                      (v5/*:: as any*/),
                      (v36/*:: as any*/),
                      (v37/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "storyTelling",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "shortTitles",
                        "value": true
                      }
                    ],
                    "concreteType": "StoryTellingModule",
                    "kind": "LinkedField",
                    "name": "storyTellingModule",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoryTellingTab",
                        "kind": "LinkedField",
                        "name": "tabs",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tabType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tabTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "contentHeader",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoryTellingModuleCreator",
                            "kind": "LinkedField",
                            "name": "contentCreatorAttribution",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "creatorName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LinkData",
                                "kind": "LinkedField",
                                "name": "creatorBrowseUrl",
                                "plural": false,
                                "selections": (v39/*:: as any*/),
                                "storageKey": null
                              },
                              (v8/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "contentBodyText",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mainImage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mainVideo",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LinkData",
                            "kind": "LinkedField",
                            "name": "browseLink",
                            "plural": false,
                            "selections": (v39/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "smallImage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "storyTellingModule(shortTitles:true)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCustomizable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDyoCustomizable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemAttributes",
                    "kind": "LinkedField",
                    "name": "attributes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "kind": "LinkedField",
                        "name": "customizable",
                        "plural": true,
                        "selections": [
                          (v41/*:: as any*/),
                          (v42/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "kind": "LinkedField",
                        "name": "ringResizable",
                        "plural": true,
                        "selections": [
                          (v41/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "kind": "LinkedField",
                        "name": "leadTime",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AttributeOption",
                            "kind": "LinkedField",
                            "name": "option",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "urlLabel",
                                "storageKey": null
                              },
                              (v5/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "kind": "LinkedField",
                        "name": "framingStatus",
                        "plural": true,
                        "selections": (v23/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isListingMigrated",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "seoDescription",
                    "storageKey": null
                  },
                  (v17/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PdpDetail",
                    "kind": "LinkedField",
                    "name": "pdpDetailsDisplay",
                    "plural": true,
                    "selections": [
                      (v43/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "delimiter",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "detailDisplayName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "detailValues",
                        "plural": true,
                        "selections": [
                          (v8/*:: as any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isPdpDetailValueInterface"
                          },
                          (v43/*:: as any*/),
                          (v44/*:: as any*/),
                          (v24/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayDetails",
                            "storageKey": null
                          },
                          (v37/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "price",
                                "plural": false,
                                "selections": [
                                  (v48/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "PdpDetailVersionsValue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RingSizeDetail",
                                "kind": "LinkedField",
                                "name": "ringSizes",
                                "plural": true,
                                "selections": (v49/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "PdpDetailRingSize",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAvailable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSold",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPrivateListing",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isListingUnlisted",
                    "storageKey": null
                  },
                  (v50/*:: as any*/),
                  {
                    "alias": "categoryL2",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "level",
                        "value": 2
                      }
                    ],
                    "concreteType": "Category",
                    "kind": "LinkedField",
                    "name": "getCategoriesByLevel",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "key",
                        "storageKey": null
                      },
                      (v5/*:: as any*/)
                    ],
                    "storageKey": "getCategoriesByLevel(level:2)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasShipmentQuotes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "defaultSkuId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v25/*:: as any*/),
                    "concreteType": "ReturnPolicy",
                    "kind": "LinkedField",
                    "name": "returnPolicy",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accept",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReturnPolicyCopy",
                        "kind": "LinkedField",
                        "name": "buyerCopy",
                        "plural": false,
                        "selections": [
                          {
                            "condition": "afterDisplay",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  (v51/*:: as any*/)
                                ],
                                "concreteType": "InlineCtaCopy",
                                "kind": "LinkedField",
                                "name": "returnPolicySection",
                                "plural": false,
                                "selections": (v52/*:: as any*/),
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "InlineCtaCopy",
                            "kind": "LinkedField",
                            "name": "customizableDetailReturnCopy",
                            "plural": false,
                            "selections": (v52/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "InlineCtaCopy",
                            "kind": "LinkedField",
                            "name": "returnPolicySectionHeader",
                            "plural": false,
                            "selections": (v52/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v5/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "itemAddress",
                        "args": (v18/*:: as any*/),
                        "kind": "ScalarField",
                        "name": "displayCityStateCountry",
                        "storageKey": "displayCityStateCountry(fullCountryName:true)"
                      },
                      (v5/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isUnpurchasable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isMultiSku",
                    "storageKey": null
                  },
                  {
                    "alias": "priceType",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "buyerId",
                        "value": ""
                      },
                      (v53/*:: as any*/),
                      {
                        "kind": "Literal",
                        "name": "isTrade",
                        "value": false
                      }
                    ],
                    "concreteType": "ItemDisplayPriceType",
                    "kind": "LinkedField",
                    "name": "displayPrice",
                    "plural": true,
                    "selections": [
                      (v54/*:: as any*/)
                    ],
                    "storageKey": "displayPrice(buyerId:\"\",catchNonFatalErrors:false,isTrade:false)"
                  },
                  {
                    "alias": "recommendedPrice",
                    "args": (v57/*:: as any*/),
                    "concreteType": "PricingGuidance",
                    "kind": "LinkedField",
                    "name": "pricingGuidance",
                    "plural": false,
                    "selections": [
                      (v60/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "kind": "LinkedField",
                        "name": "medianAmount",
                        "plural": false,
                        "selections": (v59/*:: as any*/),
                        "storageKey": null
                      },
                      (v61/*:: as any*/),
                      (v62/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v27/*:: as any*/),
                  (v63/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemClassification",
                    "kind": "LinkedField",
                    "name": "classification",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "creationDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemCategory",
                        "kind": "LinkedField",
                        "name": "categories",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "precedence",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Category",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": [
                              (v64/*:: as any*/),
                              (v44/*:: as any*/),
                              (v5/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemCreator",
                    "kind": "LinkedField",
                    "name": "creators",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "attribution",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Creator",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v64/*:: as any*/),
                          (v24/*:: as any*/),
                          (v5/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "breadcrumbs",
                    "plural": true,
                    "selections": [
                      (v42/*:: as any*/),
                      (v13/*:: as any*/),
                      (v38/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isPublishedPrivate",
                    "storageKey": null
                  },
                  (v65/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                      (v66/*:: as any*/),
                      (v5/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v36/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VideoVimeo",
                    "kind": "LinkedField",
                    "name": "videoVimeo",
                    "plural": false,
                    "selections": [
                      (v12/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "vimeoId",
                        "storageKey": null
                      },
                      (v8/*:: as any*/),
                      {
                        "alias": null,
                        "args": [
                          (v67/*:: as any*/),
                          (v68/*:: as any*/),
                          {
                            "kind": "Literal",
                            "name": "size",
                            "value": "w100h75"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "thumbnail",
                        "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w100h75\")"
                      },
                      {
                        "alias": "galleryThumbnail",
                        "args": [
                          (v67/*:: as any*/),
                          (v68/*:: as any*/),
                          {
                            "kind": "Literal",
                            "name": "size",
                            "value": "w1280h720"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "thumbnail",
                        "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w1280h720\")"
                      },
                      (v69/*:: as any*/),
                      (v70/*:: as any*/),
                      {
                        "alias": null,
                        "args": (v71/*:: as any*/),
                        "concreteType": "VideoVimeoFile",
                        "kind": "LinkedField",
                        "name": "fileByVideoSize",
                        "plural": false,
                        "selections": (v72/*:: as any*/),
                        "storageKey": "fileByVideoSize(size:\"adaptive\")"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VideoV2",
                    "kind": "LinkedField",
                    "name": "videoMux",
                    "plural": false,
                    "selections": [
                      (v12/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "playbackId",
                        "storageKey": null
                      },
                      (v8/*:: as any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "height",
                            "value": 75
                          },
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 100
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "thumbnail",
                        "storageKey": "thumbnail(height:75,width:100)"
                      },
                      {
                        "alias": "galleryThumbnail",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "height",
                            "value": 720
                          },
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 1280
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "thumbnail",
                        "storageKey": "thumbnail(height:720,width:1280)"
                      },
                      (v15/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "assetId",
                        "storageKey": null
                      },
                      (v69/*:: as any*/),
                      (v70/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemReviewDocumentList",
                    "kind": "LinkedField",
                    "name": "reviews",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemReview",
                        "kind": "LinkedField",
                        "name": "videoReview",
                        "plural": false,
                        "selections": [
                          (v12/*:: as any*/),
                          (v5/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v73/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemMeasurement",
                    "kind": "LinkedField",
                    "name": "measurement",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "unit",
                            "value": "IN"
                          }
                        ],
                        "concreteType": "ItemConvertedMeasurementsType",
                        "kind": "LinkedField",
                        "name": "convertedMeasurements",
                        "plural": false,
                        "selections": [
                          (v69/*:: as any*/)
                        ],
                        "storageKey": "convertedMeasurements(unit:\"IN\")"
                      },
                      {
                        "alias": "widthDimensions",
                        "args": [
                          (v74/*:: as any*/),
                          {
                            "kind": "Literal",
                            "name": "fields",
                            "value": [
                              "width"
                            ]
                          }
                        ],
                        "concreteType": "ItemDisplayMeasurementType",
                        "kind": "LinkedField",
                        "name": "display",
                        "plural": true,
                        "selections": (v49/*:: as any*/),
                        "storageKey": "display(addLabel:false,fields:[\"width\"])"
                      },
                      {
                        "alias": "heightDimensions",
                        "args": [
                          (v74/*:: as any*/),
                          {
                            "kind": "Literal",
                            "name": "fields",
                            "value": [
                              "height"
                            ]
                          }
                        ],
                        "concreteType": "ItemDisplayMeasurementType",
                        "kind": "LinkedField",
                        "name": "display",
                        "plural": true,
                        "selections": (v49/*:: as any*/),
                        "storageKey": "display(addLabel:false,fields:[\"height\"])"
                      }
                    ],
                    "storageKey": null
                  },
                  (v75/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "kind": "LinkedField",
                    "name": "sortedPhotos",
                    "plural": true,
                    "selections": [
                      (v66/*:: as any*/),
                      (v76/*:: as any*/),
                      (v5/*:: as any*/),
                      (v8/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageSkuXref",
                        "kind": "LinkedField",
                        "name": "imageSkuXrefs",
                        "plural": true,
                        "selections": [
                          (v37/*:: as any*/),
                          (v5/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "alt",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Hold",
                    "kind": "LinkedField",
                    "name": "activeHold",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayTimeToExpire",
                        "storageKey": null
                      },
                      (v5/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v79/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "viewInRoomPhotos",
                    "kind": "LinkedField",
                    "name": "viewInRoomPhotos",
                    "plural": true,
                    "selections": [
                      (v8/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "src",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "credits",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "viewInRoomPhotosCenterPosition",
                        "kind": "LinkedField",
                        "name": "centerPosition",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "top",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "left",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "viewInRoomPhotosComparatorWidth",
                        "kind": "LinkedField",
                        "name": "comparatorWidth",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "pixel",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "inches",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isListingNotListed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contemporaryTrackingString",
                    "storageKey": null
                  },
                  (v44/*:: as any*/),
                  (v80/*:: as any*/),
                  (v81/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isListingListed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceLocale",
                    "storageKey": null
                  },
                  {
                    "condition": "afterDisplayOrBtSsr",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          (v82/*:: as any*/),
                          (v83/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SkuQuantityOption",
                            "kind": "LinkedField",
                            "name": "quantitySelectOptions",
                            "plural": true,
                            "selections": [
                              (v84/*:: as any*/),
                              (v22/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "setSize",
                            "storageKey": null
                          },
                          {
                            "condition": "isMultiSku",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v79/*:: as any*/)
                            ]
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SaveSearchDataType",
                        "kind": "LinkedField",
                        "name": "saveSearchData",
                        "plural": false,
                        "selections": [
                          (v64/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "page",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          (v12/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isPrivateVisibilityType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v10/*:: as any*/),
                        "concreteType": "Transaction",
                        "kind": "LinkedField",
                        "name": "lastActiveTransaction",
                        "plural": false,
                        "selections": [
                          (v17/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasCompletedCheckout",
                            "storageKey": null
                          },
                          (v5/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "checkoutDate",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemPricing",
                        "kind": "LinkedField",
                        "name": "pricing",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "totalAmount",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConvertedAmounts",
                                "kind": "LinkedField",
                                "name": "convertedAmounts",
                                "plural": false,
                                "selections": [
                                  (v85/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "GBP",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "EUR",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "CAD",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "AUD",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "CHF",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "MXN",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "NOK",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "SEK",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "DKK",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v86/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isDeleted",
                        "storageKey": null
                      },
                      (v87/*:: as any*/),
                      {
                        "condition": "afterDisplayOrBtSsr",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSkuType",
                            "kind": "LinkedField",
                            "name": "skus",
                            "plural": true,
                            "selections": [
                              {
                                "alias": "displayPriceDefault",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "DEFAULT"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v88/*:: as any*/),
                                "storageKey": "displayPrice(priceBookName:\"DEFAULT\")"
                              },
                              {
                                "alias": "displayPriceAU",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "AU"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v88/*:: as any*/),
                                "storageKey": "displayPrice(priceBookName:\"AU\")"
                              },
                              {
                                "alias": "displayPriceEU",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "EU"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v88/*:: as any*/),
                                "storageKey": "displayPrice(priceBookName:\"EU\")"
                              },
                              {
                                "alias": "displayPriceGB",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "GB"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v88/*:: as any*/),
                                "storageKey": "displayPrice(priceBookName:\"GB\")"
                              }
                            ],
                            "storageKey": null
                          },
                          (v90/*:: as any*/)
                        ]
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v91/*:: as any*/),
                          {
                            "alias": "makeOfferVpvParams",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "excludedPurchaseStatuses",
                                "value": [
                                  "RET",
                                  "CUST"
                                ]
                              },
                              (v2/*:: as any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "pdpTrackingVpvParams",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "isMultiSku",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSkuType",
                            "kind": "LinkedField",
                            "name": "skus",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v29/*:: as any*/),
                                "concreteType": "SkuDisplayInfo",
                                "kind": "LinkedField",
                                "name": "displayInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CTADisplay",
                                    "kind": "LinkedField",
                                    "name": "ctas",
                                    "plural": false,
                                    "selections": [
                                      (v31/*:: as any*/),
                                      (v32/*:: as any*/),
                                      (v33/*:: as any*/),
                                      (v30/*:: as any*/),
                                      (v34/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "afterDisplay",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "recommendedPrice",
                        "args": (v57/*:: as any*/),
                        "concreteType": "PricingGuidance",
                        "kind": "LinkedField",
                        "name": "pricingGuidance",
                        "plural": false,
                        "selections": [
                          (v84/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v89/*:: as any*/),
                        "concreteType": "PricingGuidance",
                        "kind": "LinkedField",
                        "name": "pricingGuidance",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "price",
                            "plural": false,
                            "selections": (v92/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "minAmount",
                            "plural": false,
                            "selections": (v92/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "maxAmount",
                            "plural": false,
                            "selections": (v92/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v25/*:: as any*/),
                        "concreteType": "ReturnPolicy",
                        "kind": "LinkedField",
                        "name": "returnPolicy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "includeEuReturns",
                                "value": true
                              },
                              (v51/*:: as any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "returnDays",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isJewelrySeller",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isJewelry",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "leadTimeDisplay",
                        "storageKey": null
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": (v93/*:: as any*/)
                      },
                      (v94/*:: as any*/)
                    ]
                  },
                  {
                    "condition": "isEstimateSimilarSoldVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": "itemThumbnail",
                            "args": (v95/*:: as any*/),
                            "kind": "ScalarField",
                            "name": "firstPhotoWebPath",
                            "storageKey": "firstPhotoWebPath(size:\"thumb\")"
                          }
                        ]
                      }
                    ]
                  },
                  (v94/*:: as any*/),
                  {
                    "condition": "isPdpSimilarSoldItemsModuleVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": "categoryL3",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "level",
                                "value": 3
                              }
                            ],
                            "concreteType": "Category",
                            "kind": "LinkedField",
                            "name": "getCategoriesByLevel",
                            "plural": true,
                            "selections": (v96/*:: as any*/),
                            "storageKey": "getCategoriesByLevel(level:3)"
                          },
                          (v97/*:: as any*/),
                          (v86/*:: as any*/),
                          (v99/*:: as any*/)
                        ]
                      },
                      {
                        "condition": "afterDisplayOrBtSsr",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v90/*:: as any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "fetchPdp",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Phone",
                            "kind": "LinkedField",
                            "name": "trackedPhone",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "phoneNumber",
                                "storageKey": null
                              },
                              (v5/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v100/*:: as any*/),
                          (v8/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "dealerDetailsDisplayInfo",
                        "args": null,
                        "concreteType": "ItemDisplayInfo",
                        "kind": "LinkedField",
                        "name": "displayInfo",
                        "plural": false,
                        "selections": (v101/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "condition": "fetchUser",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": (v93/*:: as any*/)
                      }
                    ]
                  },
                  {
                    "condition": "isPdpImageGalleryRedesignVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VideoVimeo",
                        "kind": "LinkedField",
                        "name": "videoVimeo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "thumbThumbnail",
                            "args": [
                              (v67/*:: as any*/),
                              (v68/*:: as any*/),
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "w200h150"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "thumbnail",
                            "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w200h150\")"
                          },
                          {
                            "alias": "videoUrl",
                            "args": (v71/*:: as any*/),
                            "concreteType": "VideoVimeoFile",
                            "kind": "LinkedField",
                            "name": "fileByVideoSize",
                            "plural": false,
                            "selections": (v72/*:: as any*/),
                            "storageKey": "fileByVideoSize(size:\"adaptive\")"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VideoV2",
                        "kind": "LinkedField",
                        "name": "videoMux",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "thumbThumbnail",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "height",
                                "value": 150
                              },
                              {
                                "kind": "Literal",
                                "name": "width",
                                "value": 200
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "thumbnail",
                            "storageKey": "thumbnail(height:150,width:200)"
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isMultiSku",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v87/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VariableAttribute",
                        "kind": "LinkedField",
                        "name": "variableAttributes",
                        "plural": true,
                        "selections": [
                          (v17/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "VariableAttributeSortType",
                            "kind": "LinkedField",
                            "name": "variableAttributeData",
                            "plural": false,
                            "selections": [
                              (v24/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Attribute",
                                "kind": "LinkedField",
                                "name": "primaryAttribute",
                                "plural": false,
                                "selections": (v96/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SwatchSort",
                                "kind": "LinkedField",
                                "name": "swatchSort",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sortOrder",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Swatch",
                                    "kind": "LinkedField",
                                    "name": "swatch",
                                    "plural": false,
                                    "selections": [
                                      (v17/*:: as any*/),
                                      (v24/*:: as any*/),
                                      (v73/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "imageUrl",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "kind": "LinkedField",
                                        "name": "ringSize",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SwatchAttributeByNameProperties",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "us",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "mm",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "kind": "LinkedField",
                                        "name": "material",
                                        "plural": false,
                                        "selections": [
                                          (v64/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                          (v64/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "parentName",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v5/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v5/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "buyerSideSkus",
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          (v17/*:: as any*/),
                          {
                            "alias": null,
                            "args": (v95/*:: as any*/),
                            "kind": "ScalarField",
                            "name": "firstPhotoWebPath",
                            "storageKey": "firstPhotoWebPath(size:\"thumb\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemPricing",
                            "kind": "LinkedField",
                            "name": "pricing",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hidePrice",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "retailPrice",
                                "plural": false,
                                "selections": (v102/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "netPrice",
                                "plural": false,
                                "selections": (v102/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "salePrice",
                                "plural": false,
                                "selections": (v102/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v82/*:: as any*/),
                          (v83/*:: as any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "pageType",
                                "value": "PDP"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "leadTime",
                            "storageKey": "leadTime(pageType:\"PDP\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "variableAttributeSelectionsType",
                            "kind": "LinkedField",
                            "name": "variableAttributeSelections",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "VariableAttribute",
                                "kind": "LinkedField",
                                "name": "variableAttribute",
                                "plural": false,
                                "selections": (v40/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Swatch",
                                "kind": "LinkedField",
                                "name": "swatch",
                                "plural": false,
                                "selections": (v40/*:: as any*/),
                                "storageKey": null
                              },
                              (v5/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "type": "Item",
                "abstractKey": null
              },
              (v16/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "similarLandingItems",
            "args": [
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "similarItemsCount"
              },
              (v55/*:: as any*/),
              (v1/*:: as any*/),
              {
                "kind": "Literal",
                "name": "useML",
                "value": true
              }
            ],
            "concreteType": "moreLikeThisItemConnection",
            "kind": "LinkedField",
            "name": "moreLikeThisItem",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "moreLikeThisItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v17/*:: as any*/),
                      (v81/*:: as any*/),
                      (v80/*:: as any*/),
                      (v44/*:: as any*/),
                      (v27/*:: as any*/),
                      (v75/*:: as any*/),
                      (v65/*:: as any*/),
                      (v63/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemCreator",
                        "kind": "LinkedField",
                        "name": "creators",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Creator",
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": (v96/*:: as any*/),
                            "storageKey": null
                          },
                          (v5/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 1
                          }
                        ],
                        "concreteType": "ItemPhoto",
                        "kind": "LinkedField",
                        "name": "photos",
                        "plural": true,
                        "selections": [
                          (v76/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemPhotoVersion",
                            "kind": "LinkedField",
                            "name": "versions",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "webPath",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v5/*:: as any*/)
                        ],
                        "storageKey": "photos(limit:1)"
                      },
                      (v5/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*:: as any*/),
          {
            "condition": "isPdpSimilarSoldItemsModuleVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "condition": "afterDisplay",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v103/*:: as any*/),
                    "concreteType": "SimilarSoldItemsConnectionConnection",
                    "kind": "LinkedField",
                    "name": "similarSoldItemsConnection",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SimilarSoldItemsConnectionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SimilarSoldItemsNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v104/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "soldDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  (v17/*:: as any*/),
                                  (v27/*:: as any*/),
                                  (v50/*:: as any*/),
                                  (v97/*:: as any*/),
                                  (v86/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": (v77/*:: as any*/),
                                    "concreteType": "ItemDisplayPriceType",
                                    "kind": "LinkedField",
                                    "name": "displayPrice",
                                    "plural": true,
                                    "selections": (v59/*:: as any*/),
                                    "storageKey": null
                                  },
                                  (v99/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PdpDetail",
                                    "kind": "LinkedField",
                                    "name": "pdpDetailsDisplay",
                                    "plural": true,
                                    "selections": [
                                      (v43/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "detailValues",
                                        "plural": true,
                                        "selections": [
                                          (v8/*:: as any*/),
                                          (v24/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v107/*:: as any*/)
                ]
              },
              {
                "condition": "afterDisplayOrBtSsr",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v107/*:: as any*/)
                ]
              }
            ]
          },
          {
            "condition": "afterDisplay",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v103/*:: as any*/),
                "concreteType": "SimilarSoldItemsConnectionConnection",
                "kind": "LinkedField",
                "name": "similarSoldItemsConnection",
                "plural": false,
                "selections": [
                  (v105/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SimilarSoldItemsConnectionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SimilarSoldItemsNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v104/*:: as any*/),
                          (v106/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Item",
                            "kind": "LinkedField",
                            "name": "item",
                            "plural": false,
                            "selections": [
                              (v44/*:: as any*/),
                              (v80/*:: as any*/),
                              (v75/*:: as any*/),
                              (v5/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "gdprDisplayInfo",
                "kind": "LinkedField",
                "name": "gdprDisplayInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "countryCode",
                        "variableName": "userCountryCode"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "isGdprApplicable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "marketingOptInMessage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "detectFeedbackLanguage",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "detectFeedbackLanguage"
                  }
                ],
                "kind": "ScalarField",
                "name": "featureFlag",
                "storageKey": "featureFlag(feature:\"detectFeedbackLanguage\")"
              },
              {
                "alias": null,
                "args": (v7/*:: as any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "itemRead",
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v91/*:: as any*/),
                      {
                        "alias": null,
                        "args": (v25/*:: as any*/),
                        "concreteType": "Promotion",
                        "kind": "LinkedField",
                        "name": "activePromotion",
                        "plural": false,
                        "selections": (v6/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dealerSince",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemPhoto",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": (v108/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v89/*:: as any*/),
                        "concreteType": "PricingGuidance",
                        "kind": "LinkedField",
                        "name": "pricingGuidance",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "price",
                            "plural": false,
                            "selections": (v109/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "minAmount",
                            "plural": false,
                            "selections": (v109/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "maxAmount",
                            "plural": false,
                            "selections": (v109/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AbTestConfigV2UserVariant",
                            "kind": "LinkedField",
                            "name": "seoAbTestV2List",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "variant",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AbTestConfigV2",
                                "kind": "LinkedField",
                                "name": "config",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "testName",
                                    "storageKey": null
                                  },
                                  (v5/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "type": "Item",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v1/*:: as any*/),
                  {
                    "kind": "Literal",
                    "name": "pageSize",
                    "value": 10
                  },
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "personalizationId"
                  }
                ],
                "concreteType": "PersonalizedItems",
                "kind": "LinkedField",
                "name": "personalizedItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "associationType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPersonalizedItem",
                    "storageKey": null
                  },
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v3/*:: as any*/),
                "concreteType": "BuyerUrgencyInfo",
                "kind": "LinkedField",
                "name": "buyerUrgencyInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalConversations",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemUrgencyInfoType",
                    "kind": "LinkedField",
                    "name": "itemUrgency",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urgencyInfoType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "message",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "count",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasUrgencyInfo",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "country",
                    "variableName": "userCountryCode"
                  },
                  (v1/*:: as any*/)
                ],
                "concreteType": "TransactionWarningQueryType",
                "kind": "LinkedField",
                "name": "transactionWarnings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasRestrictedMaterials",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "condition": "fetchUser",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v25/*:: as any*/),
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v108/*:: as any*/),
                    "storageKey": null
                  }
                ]
              },
              {
                "condition": "isInteractivePdpChat",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v7/*:: as any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "itemRead",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Seller",
                            "kind": "LinkedField",
                            "name": "seller",
                            "plural": false,
                            "selections": [
                              (v100/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Address",
                                "kind": "LinkedField",
                                "name": "shippingAddress",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayCityStateCountry",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PresenceResults",
                                "kind": "LinkedField",
                                "name": "presence",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "recentOnlineDate",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerPreferences",
                                "kind": "LinkedField",
                                "name": "sellerPreferences",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "showOnlineStatus",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isUnavailable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ShipmentQuote",
                            "kind": "LinkedField",
                            "name": "shipmentQuotes",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isComplimentary",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isCalculated",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "totalAmount",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConvertedAmounts",
                                    "kind": "LinkedField",
                                    "name": "convertedAmounts",
                                    "plural": false,
                                    "selections": [
                                      (v85/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ShipmentServiceMethod",
                                "kind": "LinkedField",
                                "name": "serviceMethod",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Region",
                                    "kind": "LinkedField",
                                    "name": "region",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "regionName",
                                        "storageKey": null
                                      },
                                      (v5/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v5/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "buyerChatDisplayInfo",
                            "args": null,
                            "concreteType": "ItemDisplayInfo",
                            "kind": "LinkedField",
                            "name": "displayInfo",
                            "plural": false,
                            "selections": (v101/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "Item",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "presenceFeatureFlag",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "presence"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "featureFlag",
                    "storageKey": "featureFlag(feature:\"presence\")"
                  },
                  {
                    "alias": "readReceiptsFeatureFlag",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "readReceipts"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "featureFlag",
                    "storageKey": "featureFlag(feature:\"readReceipts\")"
                  },
                  {
                    "condition": "fetchUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          (v9/*:: as any*/),
                          (v1/*:: as any*/)
                        ],
                        "concreteType": "Conversation",
                        "kind": "LinkedField",
                        "name": "buyerItemConversation",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasMessageFromSeller",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Message",
                            "kind": "LinkedField",
                            "name": "messages",
                            "plural": true,
                            "selections": [
                              (v8/*:: as any*/),
                              (v5/*:: as any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "userType",
                                    "value": "BUYER"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "translatedTextBody",
                                "storageKey": "translatedTextBody(userType:\"BUYER\")"
                              },
                              (v17/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "textBody",
                                "storageKey": null
                              },
                              (v110/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fromUserId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "shipmentTrackingNumber",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MessageAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": (v96/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Anchor",
                                "kind": "LinkedField",
                                "name": "anchors",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sourceType",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MessageAttachment",
                                "kind": "LinkedField",
                                "name": "attachments",
                                "plural": true,
                                "selections": (v108/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionRequestedNetPrice",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMadePrivateOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMadeNetPriceOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMadeOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionAutomatedPrivateOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionShippingQuoteSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionSpecialShippingRequests",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionRequestedHold",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionHoldPlaced",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionHoldReleased",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionShippingQuoteRequested",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionCallInitiated",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionCustomizationOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionCustomization",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionBundledOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionPrivateOfferShippingQuoteSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionPrivateOfferHoldSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionHoldShippingQuoteSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionInternalAdminJoined",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMarkedShipped",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnRequested",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnApproved",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnDeclinedApproved",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnCompleted",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnDeclined",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionDealerCounterOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionBuyerCounterOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Offer",
                                "kind": "LinkedField",
                                "name": "offer",
                                "plural": false,
                                "selections": [
                                  (v17/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isApoFromCart",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "expirationDate",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isExpired",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isSubmitted",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isRevisedByDealer",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isCountered",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FinancialAmount",
                                    "kind": "LinkedField",
                                    "name": "amountPerItem",
                                    "plural": false,
                                    "selections": (v59/*:: as any*/),
                                    "storageKey": null
                                  },
                                  (v5/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Transaction",
                                "kind": "LinkedField",
                                "name": "transaction",
                                "plural": false,
                                "selections": [
                                  (v111/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Offer",
                                    "kind": "LinkedField",
                                    "name": "mostRecentOffer",
                                    "plural": false,
                                    "selections": (v40/*:: as any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TransactionSummaryObject",
                                    "kind": "LinkedField",
                                    "name": "summary",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "offerDiscountPercentage",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConversationMember",
                                "kind": "LinkedField",
                                "name": "from",
                                "plural": false,
                                "selections": (v40/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v17/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasUnreadMessageForMember",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConversationMember",
                            "kind": "LinkedField",
                            "name": "originalBuyer",
                            "plural": false,
                            "selections": (v40/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Transaction",
                            "kind": "LinkedField",
                            "name": "transaction",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ItemSkuType",
                                "kind": "LinkedField",
                                "name": "sku",
                                "plural": false,
                                "selections": (v40/*:: as any*/),
                                "storageKey": null
                              },
                              (v5/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrderFeedback",
                                "kind": "LinkedField",
                                "name": "orderFeedback",
                                "plural": false,
                                "selections": [
                                  (v12/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "token",
                                    "storageKey": null
                                  },
                                  (v5/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Member",
                            "kind": "LinkedField",
                            "name": "sellerMember",
                            "plural": false,
                            "selections": [
                              (v17/*:: as any*/),
                              (v5/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastConversationReadDate",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v5/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v25/*:: as any*/),
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v17/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Profile",
                            "kind": "LinkedField",
                            "name": "profile",
                            "plural": false,
                            "selections": [
                              (v28/*:: as any*/),
                              (v112/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserPreferences",
                            "kind": "LinkedField",
                            "name": "preferences",
                            "plural": false,
                            "selections": [
                              (v45/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Summary",
                            "kind": "LinkedField",
                            "name": "conversationSummary",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "unread",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "conversations",
                        "args": (v113/*:: as any*/),
                        "concreteType": "ConversationsSolrConnection",
                        "kind": "LinkedField",
                        "name": "conversationsSolr",
                        "plural": false,
                        "selections": [
                          (v105/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConversationsSolrEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Conversation",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v17/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "latestMessage",
                                    "storageKey": null
                                  },
                                  (v110/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "inboxImage",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "numberOfMessages",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Item",
                                    "kind": "LinkedField",
                                    "name": "item",
                                    "plural": false,
                                    "selections": [
                                      (v27/*:: as any*/),
                                      (v17/*:: as any*/),
                                      (v5/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ItemSkuType",
                                    "kind": "LinkedField",
                                    "name": "sku",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": "skuPhotoWebPath",
                                        "args": (v35/*:: as any*/),
                                        "kind": "ScalarField",
                                        "name": "firstPhotoWebPath",
                                        "storageKey": "firstPhotoWebPath(size:\"small\")"
                                      },
                                      (v5/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "latestMessageReceivedAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": "hasReplied",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isLatestMessageSender",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConversationMember",
                                    "kind": "LinkedField",
                                    "name": "originalBuyer",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "hasUnreadTag",
                                        "storageKey": null
                                      },
                                      (v5/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*:: as any*/),
                                  (v8/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v114/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v115/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "conversations",
                        "args": (v113/*:: as any*/),
                        "filters": [
                          "page",
                          "buyerId"
                        ],
                        "handle": "connection",
                        "key": "BuyerChatVariant_conversations",
                        "kind": "LinkedHandle",
                        "name": "conversationsSolr"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isEstimateSimilarSoldVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v116/*:: as any*/),
              {
                "condition": "afterDisplay",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "condition": "isEstimateSimilarSoldVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v116/*:: as any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "fetchPdp",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "isPdpStfEnabled",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "enablePdpStf"
                  }
                ],
                "kind": "ScalarField",
                "name": "featureFlag",
                "storageKey": "featureFlag(feature:\"enablePdpStf\")"
              }
            ]
          },
          {
            "condition": "afterDisplayOrBtSsr",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "showAddToCartButton",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "multiItemCartAddToCartButton"
                  }
                ],
                "kind": "ScalarField",
                "name": "featureFlag",
                "storageKey": "featureFlag(feature:\"multiItemCartAddToCartButton\")"
              }
            ]
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v25/*:: as any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": "hasMerchandizingPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "BUYER_FE_MERCH_TOOL"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasPermission",
                    "storageKey": "hasPermission(name:\"BUYER_FE_MERCH_TOOL\")"
                  },
                  (v17/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v112/*:: as any*/),
                      (v28/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isVerifiedTrade",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserPreferences",
                    "kind": "LinkedField",
                    "name": "preferences",
                    "plural": false,
                    "selections": [
                      (v45/*:: as any*/),
                      (v98/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canShowSellerName",
                    "storageKey": null
                  },
                  (v8/*:: as any*/),
                  (v5/*:: as any*/),
                  {
                    "condition": "isTrade",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "kind": "LinkedField",
                        "name": "tradeFirm",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "kind": "LinkedField",
                            "name": "rewards",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ParentProgram",
                                "kind": "LinkedField",
                                "name": "currentProgram",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LoyaltyProgram",
                                    "kind": "LinkedField",
                                    "name": "programInfo",
                                    "plural": false,
                                    "selections": (v6/*:: as any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": "ENHANCED_BUYER_PROTECTION"
                                      }
                                    ],
                                    "concreteType": "LoyaltyProgram",
                                    "kind": "LinkedField",
                                    "name": "childPrograms",
                                    "plural": true,
                                    "selections": (v6/*:: as any*/),
                                    "storageKey": "childPrograms(filter:\"ENHANCED_BUYER_PROTECTION\")"
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v25/*:: as any*/),
                                "concreteType": "currentPromoSegmentType",
                                "kind": "LinkedField",
                                "name": "currentPromoSegment",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "segmentCode",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v5/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "daysToExpiration",
                            "value": 7
                          },
                          {
                            "kind": "Literal",
                            "name": "promoCodes",
                            "value": [
                              "TRADEWELCOME",
                              "TRADE1STWELCOME"
                            ]
                          }
                        ],
                        "concreteType": "Promotion",
                        "kind": "LinkedField",
                        "name": "expiringPromotion",
                        "plural": false,
                        "selections": [
                          (v117/*:: as any*/),
                          (v4/*:: as any*/),
                          (v5/*:: as any*/)
                        ],
                        "storageKey": "expiringPromotion(daysToExpiration:7,promoCodes:[\"TRADEWELCOME\",\"TRADE1STWELCOME\"])"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "kind": "LinkedField",
                        "name": "tradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v25/*:: as any*/),
                            "concreteType": "currentPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "currentPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "kind": "LinkedField",
                                "name": "promotion",
                                "plural": false,
                                "selections": [
                                  (v4/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "buyerExpirationDate",
                                    "storageKey": null
                                  },
                                  (v5/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "expiringPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "expiringPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "expiringSegmentCode",
                                "storageKey": null
                              },
                              (v117/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "afterDisplayOrBtSsr",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "condition": "fetchUser",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v118/*:: as any*/),
                            "concreteType": "favoritesConnection",
                            "kind": "LinkedField",
                            "name": "favorites",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "favoritesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Favorite",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v17/*:: as any*/),
                                      (v24/*:: as any*/),
                                      (v5/*:: as any*/),
                                      {
                                        "kind": "ClientExtension",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__id",
                                            "storageKey": null
                                          }
                                        ]
                                      },
                                      (v8/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v114/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v115/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v118/*:: as any*/),
                            "filters": [],
                            "handle": "connection",
                            "key": "SharedSaveSearchContext_favorites",
                            "kind": "LinkedHandle",
                            "name": "favorites"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "isMultiSku",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds"
                  },
                  {
                    "kind": "Variable",
                    "name": "itemId",
                    "variableName": "itemIds"
                  }
                ],
                "concreteType": "TransactionConnection",
                "kind": "LinkedField",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransactionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Transaction",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v37/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isPrivateOffer",
                            "storageKey": null
                          },
                          (v111/*:: as any*/),
                          (v5/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/571.0.0-2026-08-05T11:58:36.824Z/PdpRespMarketplaceLayoutPrimaryRefetchQuery",
    "metadata": {},
    "name": "PdpRespMarketplaceLayoutPrimaryRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "acee2177c0e71ad0b9f2663e758bf74e";

export default node;
